var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',{attrs:{"disabled":_vm.disabled,"label":_vm.label,"accept":".csv","color":"secondary","outlined":"","error":_vm.error.length > 0,"dense":"","hide-details":"","loading":_vm.loading,"prepend-icon":_vm.defaultIcon},on:{"change":function($event){return _vm.fileHandler($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }